import { useTranslation } from "react-i18next";

export default function TermosModal({ isOpen, onClose }) {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          ×
        </button>
        <h1>{t("termos.titulo")}</h1>
        <div className="modal-texto">
          <p>
            {t("termos.descricao.p1")}
            <br />
            {t("termos.descricao.p2")}
            <br />
            {t("termos.descricao.p3")}
            <br />
            {t("termos.descricao.p4")}
            <br />
            {t("termos.descricao.p5")}
            <br />
            {t("termos.descricao.p6")}
            <br />
            {t("termos.descricao.p7")}
            <br />
          </p>
        </div>
      </div>
    </div>
  );
}
